import { getImageServer } from "../utils/get-image-server";
import { akamai } from "../globals";
import { debug } from "../utils/debug-log";
import medias from "./media-configs";

const { Media } = akamai.amp;

export class AmpAudioConfig extends akamai.amp.Config {
  constructor(settings) {
    super({ autoplay: settings.autoplay });
    debug.log("[AmpAudioConfig] Constructor settings:", settings);
    this._settings = settings;
    this._muted = settings.muted;
    let autoplayPolicy = "default";

    this._autoplayPolicy = autoplayPolicy;
  }
  get autoplay() {
    return super.autoplay || this.settings.autoplay;
  }
  set autoplay(flag = true) {
    debug.log("[AmpAudioConfig] SET autoplay:", flag);
    super.autoplay = flag;
  }

  get autoplayPolicy() {
    return "none";
  }
  set autoplayPolicy(value = "default") {
    debug.log("[AmpAudioConfig] SET autoplayPolicy:", value);
    this._autoplayPolicy = value;
    //super.autoplayPolicy = value;
  }

  get domain() {
    return "webmd.com";
  }

  get branding() {
    return {};
  }

  get contextmenu() {
    return null;
  }

  get controls() {
    //debug.log("[AmpAudioConfig] GET controls", super.controls);
    return true;
  }
  set controls(value) {
    debug.log("[AmpAudioConfig] SET controls:", value);
  }
  get hls() {
    return {
      data: {
        enableWorker: true,
      },
      quality: {
        startLevel: -1,
      },
      resources: [],
    };
  }
  set hls(value = null) {
    debug.log("[AmpAudioConfig] SET hls:", value);
  }
  get locales() {
    //return AMP_LOCALES;
    return super.locales;
  }
  set locales(value = {}) {
    debug.log("[AmpAudioConfig] SET locales:", value);
    super.locales = value;
  }
  get media() {
    let {
      source,
      title,
      poster,
      muted,
      metadata,
      autoplay,
      videoId,
      ccInfo,
      ccFileRoot,
      duration,
      startTime,
      chapters,
    } = this._settings;
    let sourceParts = source.split(",");
    const hasAudioPart = sourceParts.indexOf("a96k") > -1;
    if (!hasAudioPart) {
      throw `[AmpAudioConfig] Config doesn't support audio. Source is missing "a96k" part!`;
      return null;
    }

    ccInfo = Array.isArray(ccInfo) === true ? ccInfo : [];
    const imageServer = getImageServer().includes("localhost")
      ? "img.medscapestatic.com"
      : getImageServer();
    let track =
      ccInfo.length === 0
        ? []
        : ccInfo.map((info) => {
            const src =
              ccFileRoot.startsWith("http") || ccFileRoot.startsWith("//")
                ? `${ccFileRoot}${info.file}`
                : `https://${imageServer}${ccFileRoot}${info.file}`;
            return {
              kind: "captions",
              type: "application/ttml+xml",
              srclang: info.lang,
              src: src,
            };
          });

    if (poster == null || poster.trim() == "") {
      // Transparent image
      poster =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPjPBAACCgED8xRmJAAAAABJRU5ErkJggg==";
    } else if (
      poster.startsWith("http") === false &&
      poster.startsWith("//") === false
    ) {
      poster = poster.startsWith("/") ? poster : `/${poster}`;
      poster = `https://${imageServer}${poster}`;
    }

    let _startTime = startTime || 0;


    let sources = [];
    if(source.startsWith("//") || source.startsWith("http")) {
      const srcParts = source.split(".");
      const extension = srcParts.pop();
      const type = MediaTypes[extension];

      sources = type == null ? [] : [
        {
          src: source,
          type
        }
      ]
    }
    else {
      let sourceParts = typeof source === 'undefined' || source.trim() === ''  ? [] : source.split(",");
    
      sources = medias
      .filter((media) => {
        return media.type.startsWith("video") === false;
      })
      .map((config) => {
        const { host, endpoint, type, file } = config;
        const src =
          type === "application/x-mpegURL"
            ? `//${host}${endpoint}${source}${file}`
            : `//${host}${endpoint}${sourceParts[0]}a96k.mp4`;
        const _source = {
          src,
          type,
        };
        return _source;
      });
    }

    let media = new Media();
    media = Object.assign(media, {
      title: title,
      poster: poster,
      startTime: 0, //_startTime,
      //muted: muted != null ? muted : true,
      autoplay: autoplay,
      metadata: Object.assign({}, metadata, {
        videoId: videoId,
        chapters: chapters,
        duration: parseInt(duration),
        startTime: _startTime,
        muted: muted,
      }),
      medium: "audio",
      source: sources,
      src: sources[0].src,
      type: sources[0].type,
      track: track,
      duration: duration,
    });

    debug.log("[AmpAudioConfig] GET Media:", media);
    return media;
  }
  get loop() {
    let { loop } = this._settings;
    this._loop = typeof loop === "boolean" ? loop : false;

    return this._loop;
  }
  set loop(value = false) {
    debug.log("[AmpAudioConfig] SET Loop:", value);
  }
  get mode() {
    return "html";
  }
  set mode(value = "html") {
    debug.log("[AmpAudioConfig] SET mode:", value);
  }
  get muted() {
    //return akamai.amp.utils.Utils.isIOS() || this.autoplay;
    //debug.log("[AmpAudioConfig] GET muted:", this._muted)
    return this._muted;
  }
  set muted(flag) {
    debug.log("[AmpAudioConfig] SET muted:", flag);
    this._muted = flag;
  }
  get paths() {
    return {
      //"player": `${AMP_PATH}/amp.premier/`,
      // "resources": `${AMP_PATH}/resources/`,
      //"plugins": `https://${getImageServer()}/medscape-promo/streaming-video-player/amp-premier/akamai/amp/`
    };
  }
  set paths(paths = {}) {
    debug.log("[AmpAudioConfig] SET paths:", paths);
  }

  get playsinline() {
    return true;
  }
  set playsinline(flag = true) {
    debug.log("[AmpAudioConfig] SET playsinline:", flag);
  }

  get plugins() {
    let { plugins: CUSTOM_PLUGINS } = this._settings;
    CUSTOM_PLUGINS = CUSTOM_PLUGINS || {};

    const reactSettings = CUSTOM_PLUGINS.react || {};

    let DEFAULT_PLUGINS = {
      AmpEventsSources: {},
      react: Object.assign(
        {
          autoHide: 3,
          native: false,
          resources: [],
          hint: {
            enable: false,
            mode: "",
          },
        },
        reactSettings
      ),
    };

    return Object.assign(DEFAULT_PLUGINS, CUSTOM_PLUGINS);
  }
  set plugins(plugins = {}) {
    debug.log("[AmpAudioConfig] SET plugins:", plugins);
  }
  get resources() {
    let resources = this._settings.resources || [];
    debug.log("[AmpAudioConfig] GET resources:", resources);
    return resources;
  }

  set resources(resources = []) {
    debug.log("[AmpAudioConfig] SET resources:", resources);
  }

  get settings() {
    return this._settings;
  }

  set settings(value = {}) {
    debug.log("[AmpAudioConfig] SET settings:", value);
  }
}
